import { render, staticRenderFns } from "./ContactInfoEdit.vue?vue&type=template&id=5d7821f9"
import script from "./ContactInfoEdit.vue?vue&type=script&lang=js"
export * from "./ContactInfoEdit.vue?vue&type=script&lang=js"
import style0 from "./ContactInfoEdit.vue?vue&type=style&index=0&id=5d7821f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports